import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, trustFlight } from '../styles/themes';

export const TrustFlightThemeProvider: React.FunctionComponent = ({
  children,
}) => {
  return (
    <ThemeProvider theme={trustFlight}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default TrustFlightThemeProvider;
